export class HttpErrorModel {
    status: number;
    errors: string[];
    corelationId: string;
    type?: string[];
}
